<template>
  <DashboardTemplate :navMenu="true">
    <div>
      <div class="box-overflow dashboard disabled-on-print pd-b-3">
        <div>
          <h3 class="text-left text-font-24 mg-y-less">Dashboard</h3>
        </div>
        <p class="text-left text-font-16">
          <span class="text-weight-600">{{ getTitleName(type) }}</span>
          <span> {{ course.name }}</span>
        </p>
        <div v-loading="loading">
          <DashboardDetailList
            v-if="type != 4"
            :tableList="userList"
            :exportName="`${getTitleName(type)}_${course.name}`"
          />
          <DashboardDetailList
            v-else
            :tableList="userList"
            :courseId="courseId"
            :showAction="true"
            labelDate="วันที่และเวลาที่จบหลักสูตร"
            fieldDate="successDate"
            :exportName="`${getTitleName(type)}_${course.name}`"
            @print="print"
          />
        </div>
      </div>
      <div class="show-only">
        <div class="flex-display js-center ai-center">
          <CertificateCard
            :name="name"
            :lastName="lastName"
            :courseName="course.name"
            :endDate="successDate"
          />
        </div>
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import DashboardDetailList from "@/components/dashboard/DashboardDetailList";
import CertificateCard from "@/components/certificate/CertificateCard";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    DashboardDetailList,
    CertificateCard,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    courseList() {
      return this.$store.state.courseList;
    },
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      course: "",
      courseId: "",
      type: "",
      loading: true,
      userList: [],
      name: "",
      lastName: "",
      successDate: "",
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchDashboard();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.type = this.routeParams.type;
        }
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);

      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
      }
    },
    fetchDashboard() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`/dashboard/by/type/${this.courseId}/${this.type}`)
        .then((res) => {
          if (res.data.success) {
            this.userList = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchDashboard error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    print(data) {
      this.name = data.nameTH;
      this.lastName = data.surnameTH;
      this.successDate = data.successDate;
      setTimeout(() => {
        window.print();
      }, 200);
    },
    getTitleName(type) {
      if (type === "1") {
        return "สรุปรายชื่อผู้สมัครหลักสูตร";
      } else if (type === "2") {
        return "สรุปรายชื่อผู้เข้าร่วมหลักสูตร";
      } else if (type === "3") {
        return "สรุปรายชื่อผู้กำลังเรียนหลักสูตร";
      } else {
        return "สรุปรายชื่อผู้จบหลักสูตร";
      }
    },
  },
};
</script>
